import reduce from 'lodash/reduce';

import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

const isLimitationsReached = (entityName: Extract<EEntity, EEntity.routers | EEntity.decoders>) => (state: TInitialState) => {
    const limits = state.limitations[entityName];
    const entities = state[entityName];

    const selected = reduce(
        entities,
        (result, entity) => {
            if (entity.quantity === 0) {
                return result;
            }

            if (entity.selectedCost > 1) {
                result.installment += entity.quantity;
            }

            result.total += entity.quantity;

            return result;
        },
        {
            total: 0,
            installment: 0,
        },
    );

    return {
        total: selected.total >= limits.total,
        installment: selected.installment >= limits.installment,
    };
};

export default isLimitationsReached;
